<im-modal>
  <im-modal-header (dismiss)="onDismiss()"></im-modal-header>

  <div modal-content class="feedback">
    @switch (store.step()) {
      @case ('ask') {
        <img class="feedback__illustration" src="/web/images/svg/feedback-prompt.svg" alt="" />

        <h2 class="im:h2 feedback__title feedback__title--centered">
          {{ 'feedback_prompt.title_h' | translate }}
        </h2>

        <p class="im:body feedback__text feedback__text--centered">
          {{ 'feedback_prompt.subtitle_l' | translate }}
        </p>

        <div class="feedback__actions feedback__actions--split">
          <button im-button class="inverted" (click)="onNegative()">
            {{ 'feedback_prompt.negative_button_l' | translate }}
          </button>
          <button im-button class="primary" (click)="onPositive()">
            {{ 'feedback_prompt.positive_button_l' | translate }}
          </button>
        </div>
      }

      @case ('form') {
        <h2 class="im:h2 feedback__title">
          {{ 'feedback_prompt.form_title_h' | translate }}
        </h2>

        <p class="im:body feedback__text">
          {{ 'feedback_prompt.form_subtitle_l' | translate }}
        </p>

        <im-chip-filter
          class="feedback__chips"
          [items]="categories"
          [ngModel]="selectedCategories()"
          (ngModelChange)="onCategoriesChange($event)"
        >
          <ng-template let-item>
            @if (categoryIcons()[item.value]; as icon) {
              <rs-web-icon [icon]="icon" [size]="12"></rs-web-icon>
            }
            {{ item.label | translate }}
          </ng-template>
        </im-chip-filter>

        <im-signal-form-field class="feedback__comment">
          <label class="im:floating-label">
            <span floatingLabel>{{ 'feedback_prompt.comment_label_l' | translate }}</span>
            <textarea
              class="im:input feedback__textarea"
              rows="3"
              [placeholder]="'feedback_prompt.comment_label_l' | translate"
              [formField]="feedbackForm.comment"
            ></textarea>
          </label>
          <span class="im:caption feedback__counter">
            {{ commentLength() }}/{{ maxCommentLength }}
          </span>
        </im-signal-form-field>

        <p class="im:body feedback__privacy">
          {{ 'feedback_prompt.privacy_l' | translate }}
          <a im-button href="/legal?link=privacy" target="_blank">
            {{ 'feedback_prompt.privacy_link_l' | translate }}
          </a>
        </p>

        <div class="feedback__actions">
          <button im-button class="primary" [disabled]="!canSubmit()" (click)="onSubmit()">
            {{ 'feedback_prompt.submit_button_l' | translate }}
          </button>
        </div>
      }

      @case ('thanks') {
        <span class="feedback__success" aria-hidden="true">
          <rs-web-icon [icon]="ImmomioIconName.CheckOutlined" [size]="24"></rs-web-icon>
        </span>

        <h2 class="im:h2 feedback__title feedback__title--centered">
          {{ 'feedback_prompt.thanks_title_h' | translate }}
        </h2>

        <p class="im:body feedback__text feedback__text--centered">
          {{ 'feedback_prompt.thanks_subtitle_l' | translate }}
        </p>

        <div class="feedback__actions">
          <button im-button class="primary" (click)="onDone()">
            {{ 'feedback_prompt.done_button_l' | translate }}
          </button>
        </div>
      }
    }
  </div>
</im-modal>
